// this file is automatically generated by git-version script
export const version = {
  name: 'amg-provider-client',
  version: '1.57.0',
  commit: 'b6132a41baa6d5aba9412760edf030da7e3a24ca',
  branch: 'platinum',
  dateGenerated: '2026-01-12T15:42:07.744Z',
};